export const menuLinks = [
	{ name: 'Home', path: '/' },
	{ name: 'Menu', path: '/menu' },
	{ name: 'About', path: '/about' },
];
